var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconIsLoaded)?_c('IconifyIcon',{staticClass:"Icon iconify",attrs:{"icon":_vm.icon,"inline":_vm.inline}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }